module.exports = __webpack_public_path__ + "static/scale-model-of-i-10-eastern-terminus-in-jacksonville-florida-465cc023f6e148a2c654f8282613573c.png";